import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../assets/css/admin/AdminSidebar.css";


const AdminSidebar = () => {
  const [openMenus, setOpenMenus] = useState({});

  const toggleSubMenu = (key) => {
    setOpenMenus((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  const [isCollapsed, setIsCollapsed] = useState(false);
      
  return (
    <div className={`nk-sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div className="nk-nav-scroll">
                {/* <ul>
                  <li className="hamburger"  onClick={() => setIsCollapsed(!isCollapsed)}>
                    <span className="toggle-icon">
                      <i className="icon-arrow-right"></i>
                    </span>
                  </li>
                </ul> */}
               
              {adminMenu.map((section, sectionIndex) => (
              <div className="sidebar-section" key={sectionIndex}>
                <p className="sidebar-title">{section.title}</p>

                <ul className="metismenu">
                  {section.items.map((item, index) => (
                    <li key={index}>
                      {item.subItems ? (
                        <>
                          <a
                            href="#"
                            className="has-arrow sidebar-item nav-link active"
                            onClick={(e) => {
                              e.preventDefault();
                              toggleSubMenu(item.label);
                            }}
                          >
                            <i className={item.icon}></i>
                            <span>{item.label}</span>
                          </a>

                          {openMenus[item.label] && (
                            <ul className="submenu">
                              {item.subItems.map((sub, i) => (
                                <li key={i}>
                                  <NavLink to={sub.link}>{sub.label}</NavLink>
                                </li>
                              ))}
                            </ul>
                          )}
                        </>
                      ) : (
                        <NavLink to={item.link} className="sidebar-item">
                          <i className={item.icon}></i>
                          <span>{item.label}</span>
                        </NavLink>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
  

               
                </div>
    </div>
   
  );
};

const adminMenu = [
  {
    title: "MAIN",
    items: [
      {
        label: "Dashboard",
        icon: "icon-speedometer",
        link: "/home",
      },
      {
        label: "Jobs Management",
        icon: "icon-notebook",
        link: "/admin/jobs",
      },
      // {
      //   label: "Companies",
      //   icon: "icon-badge",
      //   link: "/admin/companies",
      // },
      {
        label: "Employers",
        icon: "icon-briefcase",
        link: "/admin/employers",
      },
      {
        label: "Job Seekers",
        icon: "icon-user",
        link: "/admin/candidates",
      },
    ],
  },

  {
    title: "OPERATIONS",
    items: [
      {
        label: "Approvals & KYC",
        icon: "icon-check",
        link: "/admin/approvals",
      },
      {
        label: "Reports & Complaints",
        icon: "icon-flag",
        link: "/admin/reports",
      },
      {
        label: "Analytics",
        icon: "icon-chart",
        link: "/admin/analytics",
      },
    ],
  },

  // {
  //   title: "SYSTEM",
  //   items: [
  //     {
  //       label: "Settings",
  //       icon: "icon-settings",
  //       link: "/admin/settings",
  //     },
  //     // {
  //     //   label: "Roles & Permissions",
  //     //   icon: "icon-shield",
  //     //   link: "/admin/roles",
  //     // },
  //   ],
  // },
];


export default AdminSidebar;
